import {
  DEV_BUYER_HOSTNAME,
  LOCALHOSTNAME,
  STAGING_BUYER_HOSTNAME,
} from '@diamond/shared/environments';
import Head from 'next/head';
interface SEONextProps {
  title: string;
  description?: string;
}

export function SEONext(props: SEONextProps) {
  const pageDescription =
    props.description ||
    'Nikmati berbagai kemudahan untuk kebutuhan bisnis Anda dimanapun kapanpun dengan Sukanda Onelink.';
  const getEnv = (): string => {
    if (typeof window === 'undefined') {
      return '';
    }
    switch (window.location.hostname) {
      case DEV_BUYER_HOSTNAME:
        return '- Dev';
      case STAGING_BUYER_HOSTNAME:
        return '- Staging';
      case LOCALHOSTNAME:
        return '- Local';
      default:
        return '';
    }
  };

  const pageTitle =
    getEnv() === '' ? `${props.title}` : `${props.title} ${getEnv()}`;

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
    </Head>
  );
}
